import { useTranslation } from "react-i18next";
import classes from "./pagnationComponet.module.css";

const PaginationComponent = ({ setCurrentPage, currentPage, totalItems, itemsPerPage }) => {
  const {t}=useTranslation()
  const totalPages = itemsPerPage
  const visiblePages =25; 
  const halfVisiblePages = Math.floor(visiblePages / 2);

  const startPage = Math.max(1, currentPage - halfVisiblePages);
  const endPage = Math.min(totalPages, currentPage + halfVisiblePages);

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handlePageClick = (page) => {
    if (page >= 1 && page <= totalPages && page !== currentPage) {
      setCurrentPage(page);
    }
  };

  return (  
    <ul className={classes.pagnationList}>
      <li>
        <button onClick={handlePrevPage} disabled={currentPage === 1}>
         {t("Prev")}
        </button>
      </li>

      {startPage > 1 && (
        <>
          <li>
            <button onClick={() => handlePageClick(1)}>1</button>
          </li>
          {startPage > 2 && <li>...</li>} 
        </>
      )}

      {Array.from({ length: endPage - startPage + 1 }, (_, index) => {
        const pageNumber = startPage + index;
        return (
          <li key={pageNumber}>
            <button
              className={`${currentPage === pageNumber ? classes.pageNum : ''}`}
              onClick={() => handlePageClick(pageNumber)}
            >
              {pageNumber}
            </button>
          </li>
        );
      })}

      {endPage < totalPages && (
        <>
          {endPage < totalPages - 1 && <li>...</li>} 
          <li>
            <button onClick={() => handlePageClick(totalPages)}>{totalPages}</button>
          </li>
        </>
      )}

      <li>
        <button onClick={handleNextPage} disabled={currentPage === totalPages}>
          {t("Next")}
        </button>
      </li>
    </ul>
  );
};

export default PaginationComponent;